import { ReactNode } from 'react';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { Link } from 'react-router-dom';

interface IProps {
  icon: ReactNode;
  text?: string | ReactNode;
  divider?: boolean;
  padding?: string;
  to: string;
  state: object;
}

export const PopUpLinkItem = ({ icon, text, divider, padding, to, state }: IProps) => {
  return (
    <Link style={{ textDecoration: 'none', color: 'inherit' }} to={to} state={state}>
      <MenuItem id="pop-up-link-item-component__components-menu-burger__menuitem__l17"
      sx={{ padding: padding ? padding : 2, width: '180px' }}
      aria-label="Home"
      divider={divider}>
        
        <ListItemIcon id="pop-up-link-item-component__components-menu-burger__listitemicon__l22">{icon}</ListItemIcon>
        {text && <ListItemText id="pop-up-link-item-component__components-menu-burger__listitemtext__l23">{text}</ListItemText>}
      </MenuItem>
    </Link>);

};